import api from './apiService';

const BASE_URL = 'financeiro/clientes/';

export const getClientes = async (params = {}) => {
  const response = await api.get(BASE_URL, { params });
  return response.data;
};

export const getCliente = async (id) => {
  const response = await api.get(`${BASE_URL}${id}/`);
  return response.data;
};

export const createCliente = async (data) => {
  const response = await api.post(BASE_URL, data);
  return response.data;
};

export const updateCliente = async (id, data) => {
  const response = await api.patch(`${BASE_URL}${id}/`, data);
  return response.data;
};

export const deleteCliente = async (id) => {
  await api.delete(`${BASE_URL}${id}/`);
};

export const reativarCliente = async (id) => {
  const response = await api.post(`${BASE_URL}${id}/reativar/`);
  return response.data;
};

export const getClienteHistorico = async (id) => {
  const response = await api.get(`${BASE_URL}${id}/historico/`);
  return response.data;
};

export const getAReceber = async (params = {}) => {
  const response = await api.get('financeiro/a-receber/', { params });
  return response.data;
};
